export function convertCostValue(value: string | number) {
  typeof value === 'string' && (value = value.replace(/\$/g, ''));
  const converted =
    typeof value === 'string'
      ? parseInt(value.replace(/\.00$/, ''))
      : Math.ceil(value);
  return converted.toLocaleString('en-US');
}

export function stringToNumber(value: string) {
  typeof value === 'string' && (value = value.replace(/\$/g, ''));
  const converted =
    typeof value === 'string' ? Math.ceil(parseFloat(value)) : Math.ceil(value);
  return Number.isNaN(converted) ? 0 : converted;
}

export function unFormatCurrency(formattedValue: string) {
  const regex = /\d+(?:,\d+)?(?:\.\d+)?/g;
  const match = regex.exec(formattedValue);

  if (match) {
    return match[0].replace(',', '');
  }

  return '';
}

//check if a value is a number and not 0
export function isValidNumber(value: number | string | undefined): boolean {
  return value !== 0 && !isNaN(value as number);
}

export function toENLocale(value: number | undefined): string {
  if (!value) {
    value = 0;
  }
  return value.toLocaleString('en', { minimumFractionDigits: 2 });
}
